export default __webpack_public_path__ + "static/media/Michael-Soyza.7efa3b57.png";